module.exports = __webpack_public_path__ + "img/assistenza.2ca73977.png";